export const ADD_FILTER = "SEARCH_ADD_FILTER"
export const ADD_SEARCH = "SEARCH__ADD"
export const ADD_SEARCH_ENTITY = "SEARCH__ADD_SEARCH_ENTITY"
